/**
 * This file contains typography definitions (not all, just the ones needed for components)
 * to be used within components that have a custom style.
 * This file is useful while we don't have a Typography component.
 */

import typographyStyles from '../css_baseline/typography_styles';
var typography = theme => {
  var styles = typographyStyles(theme);
  return {
    body: styles['body, .body, .body-regular'],
    bodyLarge: styles['.body-large'],
    titleLarge: styles['h1, .title-large, .title-large--light'],
    titleMedium: styles['h2, .title-medium, .title-medium--light'],
    titleRegular: styles['h3, .title-regular, .title-regular--light'],
    titleSmall: styles['h4, .title-small, .title-small--light'],
    subtitleLarge: styles['h5, .subtitle-large, .subtitle-large--light'],
    subtitleRegular: styles['h6, .subtitle-regular, .subtitle-regular--light'],
    caption: styles['.caption, .caption-regular'],
    captionSmall: styles['.caption-small'],
    label: styles['.label, .label-regular'],
    labelSmall: styles['.label-small'],
    overlineRegular: styles['.overline, .overline-regular'],
    overlineLarge: styles['.overline-large'],
    fontMedium: styles['.font-medium']
  };
};
export default typography;